import script from "./monitEquip.vue?vue&type=script&setup=true&lang=js"
export * from "./monitEquip.vue?vue&type=script&setup=true&lang=js"

import "./monitEquip.vue?vue&type=style&index=0&id=458a83b6&lang=scss"

const __exports__ = script;

export default __exports__